import { Pencil, Trash } from 'tabler-icons-react';
import { clx } from 'Utils';
import { Button } from 'Elements';
import styles from 'partials/dashboard/user-content.module.scss';

export const DataTableOperation = ({ ...props }) => {
	return (
		<div className={styles.tableActionGroup}>
			{props.hasEdit && (
				<Button
					title="ویرایش"
					className={clx(styles.tableAction, styles.tableActionIcon)}
					onClick={props.onEditRow}>
					<Pencil size={20} color="#338762" />
				</Button>
			)}
			{props.hasDelete && (
				<Button
					title="حذف"
					className={clx(styles.tableAction, styles.tableActionIcon)}
					onClick={props.onDeleteRow}>
					<Trash size={20} color="#FF6868" />
				</Button>
			)}
		</div>
	);
};

DataTableOperation.defaultProps = {
	hasEdit: true,
	hasDelete: true
};
